
import { Component, Vue } from 'vue-property-decorator'
import { getStorehouseMonitor, setOperation } from '@/api/monitor'
import { getCompanyList } from '@/api/admin'
import { IListData } from '@/api/types'

@Component({
  name: 'storehouse'
})
export default class extends Vue {
  private list: IListData[] = []
  private total: number = 0
  private listLoading = true
  private companyId = ''
  private dialogFormVisible = false
  private time:number = 60
  private act:string = '0'
  private options = []
  private actionId: number = 0
  private value= ''
  private title = '报警处理措施'
  private listQuery = {
    page: 1,
    pagesize: 10,
    companyId: 0,
    state: 0
  }
  private initForm = {
    operation: ''
  }
  private formLabelWidth = '120px'
  private form = { ...this.initForm }
  created() {
    this.listQuery.companyId = Number(this.$route.query.id)
    this.getList()
    this.getCompany()
    let _this = this
    let time = setInterval(() => {
      if (_this.time <= 0) {
        this.getList()
        _this.time = 60
      } else {
        _this.time--
      }
    }, 1000)
  }
  private async submitHandle() {
    if (this.form.operation) {
      const { data } = await setOperation({ id: this.actionId, ...this.form })
      this.$message({
        type: 'success',
        message: '处理成功!'
      })
      this.getList()
      this.dialogFormVisible = false
    } else {
      this.$message({
        type: 'success',
        message: '请选择处理方法!'
      })
    }
  }
  private async getList() {
    this.listLoading = true
    const { data } = await getStorehouseMonitor(this.listQuery)
    this.total = data.total
    this.list = data.items
    this.listLoading = false
  }
  private async getCompany() {
    const queryData = {
      page: 1,
      pagesize: 100
    }
    const { data } = await getCompanyList(queryData)
    this.options = data.items
    this.companyId = ''
  }
  private async handleCurrentChange(page:number) {
    this.listQuery.page = page
    this.getList()
  }
  private actionHandle(id: number) {
    this.actionId = id
    this.dialogFormVisible = true
  }
  private async seachCondition(st:string, dat:number) {
    if (st === 'com') {
      this.listQuery.companyId = Number(this.companyId)
    }
    if (st === 'st') {
      this.listQuery.state = dat
      this.act = String(dat)
    }
    this.getList()
  }
}
